export default {
    methods: {
        verifyPhone(event) {
            console.log(event)
            var reg = /^1[3456789]\d{9}$/;
             if(!reg.test(event.target.value)&&!_.isEmpty(event.target.value)){
                 event.target.focus()
                 this.$toast.add({severity: 'error', summary: '手机号格式不正确！', life: 2000});
             }
                },
        verifyEmail (event) {
            var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
            if(!reg.test(event.target.value)&&!_.isEmpty(event.target.value)){
                event.target.focus()
                this.$toast.add({severity: 'error', summary: '邮箱格式不正确！', life: 2000});
            }
        },
        verifyIdCard(event) {
            var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if(!reg.test(event.target.value)&&!_.isEmpty(event.target.value)){
                event.target.focus()
                this.$toast.add({severity: 'error', summary: '身份证号格式不正确！', life: 2000});
            }
        },
    }
}